import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW0D01Model } from './kymw0d01.model';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0D00InputModel } from '../kymw0d00/vo/kymw0d00-input.model';

/**
 * 処理ログ画面を管理するクラス
 *
 * @export KYMW0D01Component
 * @class KYMW0D01Component
 */
@Component({
  selector: 'app-kymw0d01',
  templateUrl: 'kymw0d01.component.html',
  styleUrls: ['kymw0d01.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0D01Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw0D01Model: KYMW0D01Model = new KYMW0D01Model();

  /**
		 * 受渡情報ＶＯ
		 */
  public inputVO: KYMW0D00InputModel;

  /**
   *Creates an instance of KYMW0D01Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0D01Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0D01Component
   */
  public ngOnInit(): void {
    this.kymw0D01Model.kymw0D01Component = this;
    this.componentName = 'KYMW0D01';

    const numberbase = new Intl.NumberFormat();
    this.kymw0D01Model.normalNum = numberbase.format(this.inputVO.normalNum) + ' 件';
    this.kymw0D01Model.attentionNum = numberbase.format(this.inputVO.attentionNum) + ' 件';
    this.kymw0D01Model.abnormalNum = numberbase.format(this.inputVO.abnormalNum) + ' 件';
    this.kymw0D01Model.updateNum = numberbase.format(this.inputVO.updateNum) + ' 件';
    this.kymw0D01Model.manageNum = numberbase.format(this.inputVO.manageNum) + ' 件';
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0D01Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW0D00InputModel>param;
  }

}
